import { Injectable } from '@angular/core';
import { UrlService } from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';

@Injectable({
	providedIn: 'root',
})
export class FilenameLanguageTranslationRequester extends DcBaseRequester<
	ReadonlyArray<string>
> {
	protected elementsListUrl: string;
	protected resource: string;
	protected singleElementUrl: string;
	protected fileNamePreviewUrl: string;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('SMALL_LANGUAGE_TRANSLATE');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
		this.fileNamePreviewUrl = this.generateResourceUrl('SMALL_LANGUAGE_TRANSLATE_FILE_NAME');
	}

	public predictOutputFileName(
		pathsToDeduce: Array<string>,
		datablockId: number | undefined = undefined
	): Observable<ReadonlyArray<string>> {
		const url = this.urlService.generateUrl(
			this.elementsListUrl,
			{},
			{
				project: this.projectId,
				datablock: datablockId,
			}
		);
		return this.http.post<ReadonlyArray<string>>(url, pathsToDeduce);
	}

	public predictOutputFileNameWithExtension(
        pathsToDeduce: Array<string>,
        datablockId: number | undefined,
        config: { 
            active: boolean; 
            value: string; 
            format: string 
        }
    ): Observable<ReadonlyArray<string>> {
        const url = this.urlService.generateUrl(
            this.fileNamePreviewUrl, 
            {},
            {
                project: this.projectId,
                datablock: datablockId,
            }
        );

        const body = {
            paths: pathsToDeduce,
            use_browser_timezone: false,
            custom_extension_active: config.active,
            custom_extension_value: config.value,
            export_type: config.format.toUpperCase()
        };

        return this.http.post<ReadonlyArray<string>>(url, body);
    }
}
